import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import './HelpTooltip.css';

const HelpTooltip = ({ title, content }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [coords, setCoords] = useState({ top: 0, bottom: undefined, left: 0, position: 'center', isTop: false });
  const containerRef = useRef(null);

  useEffect(() => {
    const handleDocumentMouseDown = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsPinned(false);
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleDocumentMouseDown);
    return () => document.removeEventListener('mousedown', handleDocumentMouseDown);
  }, []);

  const handleMouseEnter = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const tooltipWidth = 300; 
      const center = rect.left + rect.width / 2;
      
      let position = 'center';
      if (center < tooltipWidth / 2 + 20) {
        position = 'left';
      } else if (window.innerWidth - center < tooltipWidth / 2 + 20) {
        position = 'right';
      }
      
      // Use viewport-relative coords since tooltip is portaled to body with position:fixed
      let topVal = rect.bottom;
      let bottomVal = undefined;
      let isTop = false;

      // Flip above if too close to the bottom of the viewport
      if (rect.bottom + 160 > window.innerHeight) {
        topVal = undefined;
        bottomVal = window.innerHeight - rect.top + 10;
        isTop = true;
      }
      
      setCoords({
        top: topVal,
        bottom: bottomVal,
        left: center,
        position,
        isTop
      });
    }
    setIsVisible(true);
  };

  const handleClick = () => {
    setIsPinned((prevPinned) => {
      const nextPinned = !prevPinned;
      setIsVisible(nextPinned);
      return nextPinned;
    });
  };

  const tooltipBox = isVisible ? (
    <div 
      className={`help-tooltip-box pos-${coords.position} ${coords.isTop ? 'is-top' : ''}`}
      style={{ 
        top: coords.top !== undefined ? `${coords.top}px` : 'auto', 
        bottom: coords.bottom !== undefined ? `${coords.bottom}px` : 'auto',
        left: `${coords.left}px`,
        marginTop: coords.isTop ? '0' : '10px',
        marginBottom: coords.isTop ? '10px' : '0'
      }}
    >
      {title && <h4 className="help-tooltip-title">{title}</h4>}
      <div className="help-tooltip-content">{content}</div>
    </div>
  ) : null;

  return (
    <div
      className="help-tooltip-container"
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => {
        if (!isPinned) {
          setIsVisible(false);
        }
      }}
      onClick={handleClick}
    >
      <div className="help-icon">i</div>
      {tooltipBox && createPortal(tooltipBox, document.body)}
    </div>
  );
};

export default HelpTooltip;
